import React, { useEffect, useState } from "react";
import { Card, Badge } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import axios from "axios";

const SalesChartBrand = () => {
  const [brandData, setBrandData] = useState([]);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 767 : false
  );

  useEffect(() => {
    axios
      .get("./dati_dashboard.json")
      .then((res) => {
        const orarioBrandData = res.data.AR.orario_brand || [];
        setBrandData(prepareDataForChart(orarioBrandData));
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const prepareDataForChart = (orarioBrandData) => {
    const brandSales = {};

    orarioBrandData.forEach((item) => {
      const { descrizione, valore } = item;
      brandSales[descrizione] =
        (brandSales[descrizione] || 0) + parseFloat(valore || 0);
    });

    return Object.entries(brandSales)
      .map(([brand, value]) => ({ brand, value }))
      .sort((a, b) => b.value - a.value);
  };

  const formatEuro = (val) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      maximumFractionDigits: 0,
    }).format(val || 0);

  const chartData = isMobile ? brandData.slice(0, 4) : brandData;

  return (
    <Card
      className="card bg-dark ombra card-week card-home hover-effect border-0 am-chart-card"
      style={{ borderRadius: "15px" }}
    >
      <div className="d-flex justify-content-between align-items-center px-3 am-chart-header">
        <h6
          className="text-title2 fw-bold mb-0"
          style={{ letterSpacing: "1px" }}
        >
          PERFORMANCE BRAND
        </h6>

        <Badge
          className="am-badge-orange"
          style={{ fontSize: "0.6rem" }}
        >
          TOP SALES
        </Badge>
      </div>

      <div className="am-chart-body">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{
              top: 10,
              right: 10,
              left: 0,
              bottom: isMobile ? 10 : 20,
            }}
            barSize={isMobile ? 48 : 35}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              stroke="rgba(255,255,255,0.055)"
            />

            <XAxis
              dataKey="brand"
              axisLine={false}
              tickLine={false}
              tick={{
                fill: "#9ca0a8",
                fontSize: isMobile ? 11 : 10,
                fontWeight: 700,
              }}
              interval={0}
              angle={isMobile ? 0 : -15}
              textAnchor={isMobile ? "middle" : "end"}
              tickFormatter={(value) => {
                const brand = String(value);
                return isMobile && brand.length > 10
                  ? `${brand.substring(0, 10)}…`
                  : brand;
              }}
            />

            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#9ca0a8", fontSize: 10 }}
              tickFormatter={formatEuro}
            />

            <Tooltip
              cursor={{ fill: "rgba(255,255,255,0.025)" }}
              contentStyle={{
                borderRadius: "12px",
                border: "1px solid rgba(255,255,255,0.1)",
                background: "rgba(20,22,27,0.96)",
                color: "#fff",
                boxShadow: "0 10px 30px rgba(0,0,0,0.28)",
                fontSize: "12px",
              }}
              labelStyle={{
                color: "#fff",
                fontWeight: "700",
              }}
              formatter={(value) => [
                formatEuro(value),
                "Totale Ordinato",
              ]}
            />

            <Bar dataKey="value" radius={[6, 6, 0, 0]}>
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={index === 0 ? "#f16f24" : "#5a5a5a"}
                  style={{ transition: "fill 0.3s ease" }}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default SalesChartBrand;
